import styled from 'styled-components'
import { flexDirection, FlexDirectionProps } from 'styled-system'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import { LANDING_CONTENT_WIDTH_PX } from 'Constants/Landing'

import { gap, GapProps } from 'Services/Styles'

const shouldForwardProp = (prop: string) =>
  !DIV_SHOULD_FORWARD_PROP.includes(prop)

export const Container = styled.div.withConfig({
  shouldForwardProp,
})<FlexDirectionProps & GapProps>`
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: ${LANDING_CONTENT_WIDTH_PX}px;

  ${flexDirection}
  ${gap}
`

export const ImageHolder = styled.div`
  position: relative;
  width: 100%;
  height: 160px;
  border-radius: 20px;
  overflow: hidden;

  > img {
    object-fit: cover;
  }
`
